// document.addEventListener('DOMContentLoaded', function () {

//   document.querySelectorAll('.about_fade_slider').forEach(slider => {

//     const slides = slider.querySelectorAll('.about_slide');
//     const indicators = slider.querySelectorAll('.indicator');
//     const nextBtns = slider.querySelectorAll('.about_next_btn');
//     const prevBtn = slider.querySelector('.about_prev_btn');

//     let current = 0;
//     const total = slides.length;

//     function showSlide(index) {
//       slides.forEach((slide, i) => {
//         slide.classList.toggle('is-active', i === index);
//       });
//       indicators.forEach((dot, i) => {
//         dot.classList.toggle('is-active', i === index);
//       });
//       current = index;
//     }

//     function nextSlide() {
//       showSlide((current + 1) % total);
//     }

//     function prevSlide() {
//       showSlide((current - 1 + total) % total);
//     }

//     nextBtns.forEach(btn => {
//       btn.addEventListener('click', nextSlide);
//     });

//     if (prevBtn) {
//       prevBtn.addEventListener('click', prevSlide);
//     }

//     indicators.forEach((dot, index) => {
//       dot.addEventListener('click', () => {
//         showSlide(index);
//       });
//     });

//   });

// });



document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.about_fade_slider').forEach(slider => {

    const slides = slider.querySelectorAll('.about_slide');
    const indicators = slider.querySelectorAll('.indicator');
    const nextBtns = slider.querySelectorAll('.about_next_btn');
    const prevBtn = slider.querySelector('.about_prev_btn');
    const slidesWrap = slider.querySelector('.about_slides');

    let current = 0;
    const total = slides.length;

    function setMaxHeight() {
      let maxHeight = 0;

      // 今アクティブなインデックスを保存
      const activeIndex = Array.from(slides).findIndex(slide =>
        slide.classList.contains('is-active')
      );

      slides.forEach(slide => {
        slide.classList.add('is-active');
        maxHeight = Math.max(maxHeight, slide.offsetHeight);
        slide.classList.remove('is-active');
      });

      slidesWrap.style.minHeight = maxHeight + 'px';

      // アクティブ状態を元に戻す
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === activeIndex);
      });
    }

    function showSlide(index) {
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });
      indicators.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });
      current = index;
    }

    function nextSlide() {
      showSlide((current + 1) % total);
    }

    function prevSlide() {
      showSlide((current - 1 + total) % total);
    }

    // 初期化
    setMaxHeight();

    // リサイズ対応（SP切替・改行変化）
    let resizeTimer;
    window.addEventListener('resize', () => {
      cancelAnimationFrame(resizeTimer);
      resizeTimer = requestAnimationFrame(setMaxHeight);
    });

    nextBtns.forEach(btn => btn.addEventListener('click', nextSlide));
    if (prevBtn) prevBtn.addEventListener('click', prevSlide);
    indicators.forEach((dot, index) => {
      dot.addEventListener('click', () => showSlide(index));
    });

  });

});



